
riot.tag2('person-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить новый контакт</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Имя</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">E-mail</label>\n          <input class="form-control" name="email" type="text">\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.item = {};
    modal.mixin('validation');
    modal.mixin('change');

    modal.rules = {
        name: 'empty'
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };
});
});


// WEBPACK FOOTER //
// ./pages/persons/person-new-modal.tag